import React, { Component } from 'react'
import FileInput from './FileInput'
import Button from './Button'
import NumberParam from './NumberParam.js'

import { randomize, defaultFAconfig, defaultRendererConfig, hasChanged } from '../graph-utils'
import spinner from '../images/Spinner.svg'

class Sidebar extends Component {
    constructor() {
        super()
        this.state = {
            shouldForceAtlasBeRunning: false,
            forceAtlasRunning: false,
            configFA: defaultFAconfig,
			configRenderer: defaultRendererConfig
        }
        this.checkFANecessity()
    }

    getSigma() { // TODO better handling of external refs
        this.sigma = window.sigma_inst
        return this.sigma !== undefined
    }

    componentDidUpdate() {
		if (!this.getSigma()) return
		// Update Force Atlas settings
        if (this.sigma.isForceAtlas2Running()) {
            this.sigma.killForceAtlas2()
            this.sigma.startForceAtlas2(this.state.configFA)
        }
		// Update renderer settings
		this.sigma.settings('labelThreshold', this.state.configRenderer.labelThreshold) 

		this.sigma.refresh()
    }

    checkFAActivity () {
        // check if the FA needs to be restarted
        if (this.getSigma() && this.state.shouldForceAtlasBeRunning && !this.forceAtlasRunning) {
            this.sigma.startForceAtlas2(this.state.configFA) 
            this.setState({
                shouldForceAtlasBeRunning: true,
                forceAtlasRunning: true
            })
        }
    }
    checkFANecessity (ms=500) {
        // check if the graph moved and stop the FA is i did not
        let old = undefined
        setInterval( () => {
            if (this.getSigma() && this.sigma.isForceAtlas2Running() &&
                old && !hasChanged(old, this.sigma.graph.nodes, 53)) {
                this.sigma.killForceAtlas2()
                this.setState({ forceAtlasRunning: false })
            }
            old = this.getSigma() && JSON.parse(JSON.stringify(this.sigma.graph.nodes().slice()))
        }, ms)
    }

    randomize = () => {
        if (!this.getSigma()) return

        // const isRunning = this.sigma.isForceAtlas2Running()
        // if (isRunning) this.sigma.killForceAtlas2()
        // if (isRunning) this.sigma.startForceAtlas2(this.state.configFA)

        randomize(this.sigma.graph.nodes())
        this.sigma.refresh()
        this.checkFAActivity()
    }

    // Parameter setters

    setGravity = (event) => {
        const newVal = event.target.value || 0
        this.setState(prevState => ({
            configFA: {
                ...prevState.configFA,
                gravity: newVal
            }
        }))
        this.checkFAActivity()
    }

    setRepulsion = (event) => {
        const newVal = Math.pow(10, event.target.value || 0 )
        this.setState(prevState => ({
            configFA: {
                ...prevState.configFA,
                scalingRatio: newVal
            }
        }))
        this.checkFAActivity()
    }

    setEdgeWeightInfluence = (event) => {
        const newVal = event.target.value || 0
        this.setState(prevState => ({
            configFA: {
                ...prevState.configFA,
                edgeWeightInfluence: newVal
            }
        }))
        this.checkFAActivity()
    }

    setSlowDown = (event) => {
        const newVal = event.target.value || 0
        this.setState(prevState => ({
            configFA: {
                ...prevState.configFA,
                slowDown: newVal > 0 ? newVal : 0.1
            }
        }))
        this.checkFAActivity()
    }

    setLabelThreshold = (event) => {
        const newVal = event.target.value || 0
        this.setState(prevState => ({
            configRenderer: {
                ...prevState.configRenderer,
                labelThreshold: newVal > 0 ? newVal : 0
            }
        }))
		// this.sigma.settings('labelThreshold', newVal > 0 ? newVal : 0) 
    }

    render() {
        return (
            <div className='Sidebar fl dib ma2 bw2 shadow-5 w-25 absolute black bg-white o-90 z-1'>
                <FileInput />

                <ParamBlock title='Actions'>
                    <ul style={{listStyle: "none", paddingLeft: "0"}}>
                        <li>
                            <Button className='w-70' onClick={() => {
                                if (!this.getSigma())
                                    return
                                // Use kill and not stop to take account of layout changes
                                if (this.state.shouldForceAtlasBeRunning) this.sigma.killForceAtlas2()
                                else this.sigma.startForceAtlas2(this.state.configFA)

                                this.setState({
                                    shouldForceAtlasBeRunning: !this.state.shouldForceAtlasBeRunning,
                                    forceAtlasRunning: !this.state.shouldForceAtlasBeRunning
                                })
                            }}>
                            Force atlas <br /> {this.state.shouldForceAtlasBeRunning ? '◼' : '►'}
                        </Button>
                        {this.state.forceAtlasRunning && <img className='fr' alt='loader' src={spinner} width="42"/>}
                    </li>
                    <li>
                        <Button className='w-70' onClick={this.randomize} alt='loader'>
                            Randomize
                        </Button>
                    </li>
                </ul>
            </ParamBlock>

            <ParamBlock title='Parameters' fontSize='4'>
                <form className='pa2'>
                    <fieldset id='parameters' className='bn'>
                        <div className='flex items-center mb2'>
                            <ul style={{listStyle: "none", paddingLeft: "0"}}>
                                <li>
                                    <NumberParam value={Math.log10(this.state.configFA.scalingRatio)}
                                        onChange={this.setRepulsion}
                                        step={1}
                                    >
                                        repulsion
                                    </NumberParam>
                                </li>
                                <li>
                                    <NumberParam value={this.state.configFA.gravity}
                                        onChange={this.setGravity}
                                        step={10}
                                    >
                                        gravity
                                    </NumberParam>
                                </li>
                                <li>
                                    <NumberParam value={this.state.configFA.edgeWeightInfluence}
                                        onChange={this.setEdgeWeightInfluence}
                                        step={0.1}
                                    >
                                        edge weight influence
                                    </NumberParam>
                                </li>
                                <li>
                                    <NumberParam value={this.state.configFA.slowDown}
                                        onChange={this.setSlowDown}
                                        step={0.1}
                                    >
                                        slow down factor
                                    </NumberParam>
                                </li>
                                <li>
                                    <NumberParam value={this.state.configRenderer.labelThreshold}
                                        onChange={this.setLabelThreshold}
                                        step={1}
                                    >
                                        label threshold
                                    </NumberParam>
                                </li>
                            </ul>
                            {
                                // <input className='mr2' type='checkbox' id='spacejam' />
                                // <label htmlFor='spacejam' className='lh-copy'>Space Jam</label>
                            }
                        </div>
                    </fieldset>
                </form>
            </ParamBlock>
        </div>
        )
    }
}


const ParamBlock = ({ title, children, fontSize='3' }) => {
    return (
        <div className='ma3 pb2 bb b--black-10'>
            <div className={'b black f'+ fontSize}>
                {title}
            </div>
            {children}
        </div>
    )
}

export default Sidebar



// WEBPACK FOOTER //
// ./src/components/Sidebar.js